import styled from '@emotion/styled';

import { LocalizedLink } from '../../../LocalizedLink/LocalizedLink';

export const StyledLocalizedLink = styled(LocalizedLink)`
  line-height: 0;
`;
